export default {
  data () {
    return {
      selectCurrentMaxPage: 1,
      selectCurrentPage: 1
    }
  },
  mounted () {
    if (!this.showSearch) return
    this.bindSelectScroll()
  },
  destroyed () {
    if (!this.showSearch) return
    this.$dropEl.removeEventListener('scroll', this.selectScroll)
  },
  methods: {
    bindSelectScroll () {
      try {
        this.$dropEl = this.$refs.Select.$refs.dropdown.$el
        this.$dropEl.addEventListener('scroll', this.selectScroll)
      } catch (err) {
        console.error(err)
      }
    },
    selectScroll () {
      if (this.selectCurrentPage === this.selectCurrentMaxPage) return
      let calculateHeight = this.$dropEl.scrollHeight - this.$dropEl.offsetHeight
      if (this.$dropEl.scrollTop - calculateHeight >= 0) {
        this.selectCurrentPage = Math.min(this.selectCurrentMaxPage, this.selectCurrentPage + 1)
        this.searchQueryPage(true).then(data => {
          this.treeResultList.push(...data.data)
        })
      }
    }
  }
}
